<template>
    <div class="content">

        <SplitText :is-type="'h1'" class="t-h1 title anim-line-3">
            <span>
                Insights that matter most
            </span>
        </SplitText>

        <div class="t-text block u-relative">

            <p class="text anim-2">
                <span>
                    Get an overview of your current performance and actionable insights to make better decisions.
                </span>
            </p>

            <ul class="list anim-1">
                <li class="item">
                    SEO research
                </li>
                <li class="item">
                    Benchmarking
                </li>
                <li class="item">
                    Competitor research
                </li>
                <li class="item">
                    Analytics and tracking
                </li>
                <li class="item">
                    Monitoring and reporting
                </li>
                <li class="item">
                    Brand mentions
                </li>
            </ul>

        </div>
    </div>
</template>
<script>
import SplitText from '@/components/SplitText'

export default
{
    name: 'IA',

    components:
    {
        SplitText
    }
}
</script>
